/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pb_UseInputs */

const en_pb_use = /** @type {(inputs: Pb_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use this`)
};

const id_pb_use = /** @type {(inputs: Pb_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pakai ini`)
};

/**
* | output |
* | --- |
* | "Use this" |
*
* @param {Pb_UseInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pb_use = /** @type {((inputs?: Pb_UseInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pb_UseInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pb_use(inputs)
	return en_pb_use(inputs)
});